module.exports = __webpack_public_path__ + "fonts/MADETommySoftBoldPERSONALUSE.67dbd0f9.woff";